import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_API_URL } from "../../../utility/api";

export const adminSaasApi = createApi({
  reducerPath: "adminSaasApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_API_URL,
    prepareHeaders: (headers) => {
      const adminToken = localStorage.getItem("adminToken");
      if (adminToken) headers.set("Authorization", `Bearer ${adminToken}`);
      return headers;
    },
  }),
  tagTypes: ["Plan", "Subscription"],
  endpoints: (builder) => ({
    getAdminPlans: builder.query({
      query: () => "plans",
      providesTags: ["Plan"],
    }),
    createPlan: builder.mutation({
      query: (body) => ({ url: "plans", method: "POST", body }),
      invalidatesTags: ["Plan"],
    }),
    updatePlan: builder.mutation({
      query: ({ id, ...body }) => ({ url: `plans/${id}`, method: "PUT", body }),
      invalidatesTags: ["Plan"],
    }),
    togglePlanStatus: builder.mutation({
      query: (id) => ({ url: `plans/${id}/toggle`, method: "PATCH" }),
      invalidatesTags: ["Plan"],
    }),
    deletePlan: builder.mutation({
      query: (id) => ({ url: `plans/${id}`, method: "DELETE" }),
      invalidatesTags: ["Plan"],
    }),
    getAdminSubscriptions: builder.query({
      query: ({ status = "", page = 1, limit = 20 } = {}) => ({
        url: "subscriptions",
        params: { status, page, limit },
      }),
      providesTags: ["Subscription"],
    }),
    activateSubscription: builder.mutation({
      query: (body) => ({ url: "subscriptions/activate", method: "POST", body }),
      invalidatesTags: ["Subscription"],
    }),
    cancelSubscription: builder.mutation({
      query: (id) => ({ url: `subscriptions/${id}/cancel`, method: "PATCH" }),
      invalidatesTags: ["Subscription"],
    }),
  }),
});

export const {
  useGetAdminPlansQuery,
  useCreatePlanMutation,
  useUpdatePlanMutation,
  useTogglePlanStatusMutation,
  useDeletePlanMutation,
  useGetAdminSubscriptionsQuery,
  useActivateSubscriptionMutation,
  useCancelSubscriptionMutation,
} = adminSaasApi;
